import React from 'react';

export function SectionHeader({ label, title, subtitle }) {
  return (
    <div className="text-center mb-16">
      <p className="text-sm font-semibold text-brand-orange uppercase tracking-[0.2em] mb-4">{label}</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight">{title}</h2>
      {subtitle && <p className="text-slate-600 max-w-2xl mx-auto mt-4 leading-relaxed">{subtitle}</p>}
    </div>
  );
}
